import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { WagmiConfig } from "wagmi";
import "./assets/css/bootstrap.min.css";
import "./assets/css/animate.min.css";
import "./assets/css/fontawesome-all.min.css";
import "./assets/css/react-odometer-theme.css";
import "./assets/css/default.css";
import "./assets/css/style.css";
import "./assets/css/responsive.css";
import "./assets/css/tailwind.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { wagmiConfig } from "./services/web3/walletService";
import { AuthProvider } from "./context/AuthContext";
import ProductTelemetryProvider from "./components/analytics/ProductTelemetryProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <WagmiConfig config={wagmiConfig}>
    <BrowserRouter>
      <AuthProvider>
        <ProductTelemetryProvider>
          <App />
        </ProductTelemetryProvider>
      </AuthProvider>
    </BrowserRouter>
  </WagmiConfig>
);
